import { Observable, of } from 'rxjs';

export enum PHOENIX_CONTEXTS {
  FILTER = 'filter',
  FORM = 'form',
  SORT_ITEM = 'sort-item',
  NONE = 'none',
  CONTAINER_COMPONENT = 'container-component',
};

export type PhxSizeMapType = Record<string, string>;

export abstract class PhxContextService {
  abstract getType(): PHOENIX_CONTEXTS;

  /** Observable of the size map provided by the container. Defaults to an empty map. */
  public readonly sizeMap$: Observable<PhxSizeMapType> = of({});

  /** Returns the size for a given component selector, or null if not present in the map. */
  public getSizeForSelector(sizeMap: PhxSizeMapType, selector: string): string | null {
    return sizeMap[selector] ?? null;
  }
}
